import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78613172"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center py-3 py-lg-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "container-fluid mb-0 py-3 py-lg-5 bg-gray"
}
const _hoisted_5 = {
  key: 2,
  class: "container py-3 py-lg-5"
}
const _hoisted_6 = {
  key: 3,
  class: "container py-3 py-lg-5"
}
const _hoisted_7 = { class: "title fs-4 fs-lg-4 text-center" }
const _hoisted_8 = { class: "title fs-4 fs-lg-4 text-center mb-3 mb-lg-5" }
const _hoisted_9 = {
  key: 0,
  class: "bg-white shadow rounded-4 p-2 p-lg-5 mb-3 mb-lg-5"
}
const _hoisted_10 = { class: "fw-bold fs-6 text-center mb-5" }
const _hoisted_11 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto mb-5" }
const _hoisted_12 = { class: "text-center fw-bold fs-6" }
const _hoisted_13 = { class: "text-center fw-bold fs-6 mb-3 mb-lg-5" }
const _hoisted_14 = { class: "mb-4 supplementary-text position-relative" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_17 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_18 = { class: "w-max-content col-lg-2 col-form-label px-2" }
const _hoisted_19 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_20 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_21 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_24 = {
  key: 1,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_25 = {
  key: 2,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_26 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_27 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_30 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_33 = {
  key: 3,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_34 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_35 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_38 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_41 = {
  key: 4,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_42 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_43 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "row px-0 col-lg-9" }
const _hoisted_46 = { class: "col-lg-3" }
const _hoisted_47 = { class: "input-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_49 = { class: "col-lg-1 py-2 py-lg-0 d-flex align-items-center justify-content-lg-center h-38" }
const _hoisted_50 = { class: "col-lg-3" }
const _hoisted_51 = { class: "input-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_53 = {
  key: 5,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_54 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_55 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_58 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = {
  key: 6,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_61 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_62 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_65 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_66 = {
  key: 7,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_67 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_68 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_71 = { class: "w-max-content col-form-label text-left px-2" }
const _hoisted_72 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_73 = ["placeholder"]
const _hoisted_74 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_75 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_76 = { class: "w-max-content col-form-label text-left px-2" }
const _hoisted_77 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_80 = {
  key: 8,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_81 = {
  key: 9,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_82 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_83 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_86 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_87 = ["placeholder"]
const _hoisted_88 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_89 = {
  key: 10,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_90 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_91 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_94 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_95 = ["placeholder"]
const _hoisted_96 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_97 = {
  key: 11,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_98 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_99 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_102 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_103 = ["placeholder"]
const _hoisted_104 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_105 = {
  key: 12,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_106 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_107 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "row px-0 col-lg-9" }
const _hoisted_110 = { class: "col-lg-3" }
const _hoisted_111 = { class: "input-group" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_113 = { class: "col-lg-1 py-2 py-lg-0 d-flex align-items-center justify-content-lg-center h-38" }
const _hoisted_114 = { class: "col-lg-3" }
const _hoisted_115 = { class: "input-group" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_117 = {
  key: 13,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_118 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_119 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_122 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_123 = ["placeholder"]
const _hoisted_124 = {
  key: 14,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_125 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_126 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_129 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_130 = {
  key: 15,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_131 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_132 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_135 = { class: "w-max-content col-form-label text-left px-2" }
const _hoisted_136 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_137 = ["placeholder"]
const _hoisted_138 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_139 = { class: "mx-0 px-0 col-lg-4 d-flex justify-content-between" }
const _hoisted_140 = { class: "w-max-content col-form-label text-left px-2" }
const _hoisted_141 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_142 = ["placeholder"]
const _hoisted_143 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_144 = {
  key: 16,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_145 = {
  key: 17,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_146 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_151 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_152 = ["placeholder"]
const _hoisted_153 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_154 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_155 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_156 = { value: "" }
const _hoisted_157 = ["value"]
const _hoisted_158 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_159 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_160 = { class: "row w-100" }
const _hoisted_161 = { class: "d-flex height-fit-content" }
const _hoisted_162 = ["value"]
const _hoisted_163 = { class: "label-option-multi" }
const _hoisted_164 = {
  key: 18,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_165 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_166 = { key: 0 }
const _hoisted_167 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_168 = { key: 0 }
const _hoisted_169 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_170 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_171 = ["placeholder"]
const _hoisted_172 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_173 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_174 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_175 = { value: "" }
const _hoisted_176 = ["value"]
const _hoisted_177 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_178 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_179 = { class: "row w-100" }
const _hoisted_180 = { class: "d-flex height-fit-content" }
const _hoisted_181 = ["value"]
const _hoisted_182 = { class: "label-option-multi" }
const _hoisted_183 = {
  key: 19,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_184 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_185 = { key: 0 }
const _hoisted_186 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_187 = { key: 0 }
const _hoisted_188 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_189 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_190 = ["placeholder"]
const _hoisted_191 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_192 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_193 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_194 = { value: "" }
const _hoisted_195 = ["value"]
const _hoisted_196 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_197 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_198 = { class: "row w-100" }
const _hoisted_199 = { class: "d-flex height-fit-content" }
const _hoisted_200 = ["value"]
const _hoisted_201 = { class: "label-option-multi" }
const _hoisted_202 = {
  key: 20,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_203 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_204 = { key: 0 }
const _hoisted_205 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_206 = { key: 0 }
const _hoisted_207 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_208 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_209 = ["placeholder"]
const _hoisted_210 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_211 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_212 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_213 = { value: "" }
const _hoisted_214 = ["value"]
const _hoisted_215 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_216 = { class: "col-12 px-2 px-lg-0" }
const _hoisted_217 = { class: "row w-100" }
const _hoisted_218 = { class: "d-flex height-fit-content" }
const _hoisted_219 = ["value"]
const _hoisted_220 = { class: "label-option-multi" }
const _hoisted_221 = {
  key: 21,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_222 = { class: "w-max-content col-lg-2 col-form-label word-wrapper" }
const _hoisted_223 = { key: 0 }
const _hoisted_224 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_225 = { key: 0 }
const _hoisted_226 = {
  key: 0,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_227 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_228 = ["placeholder"]
const _hoisted_229 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_230 = {
  key: 1,
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_231 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_232 = { value: "" }
const _hoisted_233 = ["value"]
const _hoisted_234 = {
  key: 2,
  class: "row mx-0 px-0 col-lg-9"
}
const _hoisted_235 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_236 = { class: "row w-100" }
const _hoisted_237 = { class: "d-flex height-fit-content" }
const _hoisted_238 = ["value"]
const _hoisted_239 = { class: "label-option-multi" }
const _hoisted_240 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_241 = { class: "fw-bold text-center mb-3 mb-lg-5 fs-6 headerTerm" }
const _hoisted_242 = { class: "text-break while-spaces term-of-use" }
const _hoisted_243 = { class: "checkbox-wrapper d-flex justify-content-center align-items-center" }
const _hoisted_244 = ["for"]
const _hoisted_245 = ["id"]
const _hoisted_246 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_247 = { class: "d-flex justify-content-center my-3 my-lg-5" }

import YelloopCheckForm from '@/components/yelloop-check/YelloopCheckForm.vue'
import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import useVuelidate from '@vuelidate/core'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { configYM } from '@/constants/datepicker'
import flatPickr from 'vue-flatpickr-component'
import { computed, nextTick, ref, toRaw, watchEffect } from 'vue'
import { REGISTER_STORE } from '@/store/constants'
import { required, requiredIf, email, minLength } from '@vuelidate/validators'
import { customMaxLength, customMaxLengthAlumni, getCookie, parseJsonData, scrollToErrors, purifyContent } from '@/utils'
import { DEFAULT_MIN_LENGTH, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import { getMessage } from '@/constants/messageCode.ts'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import dayjs from 'dayjs'
import { onMounted } from 'vue'
import ErrorMessage from '@/components/error-message'
import TargetTag from '@/components/target-tag/index.vue'
import { debounce, isEmpty, omit } from 'lodash'
import commonService from '@/services/common.service'
import { ALUMNI_QUESTION_TYPE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
const checkSubmit = ref(false)
const disableBtn = ref<boolean>(false)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
const route = useRoute()
const router = useRouter()
const store = useStore()
const registerAlumnusCommunityData = computed(() => store.getters[REGISTER_STORE.GETTERS.REGISTER_COMMUNITY_VALUE])
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const termsCommunity = computed(() => store.getters[REGISTER_STORE.GETTERS.TERMS_SERVICE_COMMUNITY])
const infoAlumnus = computed(() => store.getters[REGISTER_STORE.GETTERS.GET_INFO_ALUMNUS])
const alumnusDuplicate = computed(() => store.getters[REGISTER_STORE.GETTERS.ALUMNUS_VALIDATE_DUPLICATE])
const inviteData = computed(() => store.getters[REGISTER_STORE.GETTERS.INVITE])
const loadingData = ref(false)
const invalid = computed(() => store.getters[REGISTER_STORE.GETTERS.GET_VALIDATE_POST_COMMUNITY])
const invitedCodeNotFound = ref<boolean>(false)
const supplementaryInformation = ref<HTMLElement>()
const seeMoreBtn = ref<string>(0)
const placeholderDefault = translate('placeholder')
const additional_information_checkbox = ref({
  additional_information_checkbox1:
    communityRequiredData.value.additional_information_1_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusCommunityData.value.additional_information_1) || []
      : [],
  additional_information_checkbox2:
    communityRequiredData.value.additional_information_2_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusCommunityData.value.additional_information_2) || []
      : [],
  additional_information_checkbox3:
    communityRequiredData.value.additional_information_3_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusCommunityData.value.additional_information_3) || []
      : [],
  additional_information_checkbox4:
    communityRequiredData.value.additional_information_4_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusCommunityData.value.additional_information_4) || []
      : [],
  additional_information_checkbox5:
    communityRequiredData.value.additional_information_5_setting?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ? parseJsonData(registerAlumnusCommunityData.value.additional_information_5) || []
      : [],
  additional_information_select1:
    communityRequiredData.value.additional_information_1_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? registerAlumnusCommunityData.value.additional_information_1 ?? ''
      : '',
  additional_information_select2:
    communityRequiredData.value.additional_information_2_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? registerAlumnusCommunityData.value.additional_information_2 ?? ''
      : '',
  additional_information_select3:
    communityRequiredData.value.additional_information_3_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? registerAlumnusCommunityData.value.additional_information_3 ?? ''
      : '',
  additional_information_select4:
    communityRequiredData.value.additional_information_4_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? registerAlumnusCommunityData.value.additional_information_4 ?? ''
      : '',
  additional_information_select5:
    communityRequiredData.value.additional_information_5_setting?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? registerAlumnusCommunityData.value.additional_information_5 ?? ''
      : '',
})

const invitedCode = route.query?.invited_code

onMounted(async () => {
  checkAndHandleSnsLoginResult()
  loadingData.value = true
  try {
    await store.dispatch(REGISTER_STORE.ACTIONS.SET_INVITE, invitedCode)
    if (inviteData.value?.community_id) {
      await store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, { community_id: inviteData.value?.community_id, params: { invited_code: invitedCode } })
      await store.dispatch(REGISTER_STORE.ACTIONS.SET_TERMS_SERVICE_COMMUNITY, inviteData.value?.community_id)
      await store.dispatch(REGISTER_STORE.ACTIONS.SET_INFO_ALUMNUS, inviteData.value?.community_id)

      if (registerAlumnusCommunityData.value) {
        const payload = { ...registerAlumnusCommunityData.value }
        if (infoAlumnus.value) {
          Object.assign(payload, {
            ...omit(infoAlumnus.value, 'invited_code', 'consent_of_community', 'version_of_community'),
            consent_of_community: false,
          })
        }

        store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_COMMUNITY_VALUE, payload)
      }
    } else {
      invitedCodeNotFound.value = true
    }
  } catch (error) {
    console.log(error)
  }
  loadingData.value = false
  await nextTick()
  seeMoreBtn.value = supplementaryInformation.value?.offsetHeight
})

/**
 * When sns-authentication result is forward to login page through URL
 * after its has been handle in router-interceptor, it needed to be removed
 * from URL to avoid unwanted risks
 */
const checkAndHandleSnsLoginResult = () => {
  const { auth_token, invited_code: invitedCode } = route.query
  if (auth_token) {
    router.replace({ ...router.currentRoute, query: { invited_code: invitedCode } })
  }
}

const fullContent = ref<boolean>(false)
const SeeMore = () => {
  fullContent.value = true
}

watchEffect(() => {
  localStorage.removeItem('checkSubmit')
})
const rulesCheckbox = computed(() => {
  return {
    additional_information_checkbox1: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_1 === 1 && communityRequiredData.value.additional_information_1_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
    },
    additional_information_checkbox2: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_2 === 1 && communityRequiredData.value.additional_information_2_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
    },
    additional_information_checkbox3: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_3 === 1 && communityRequiredData.value.additional_information_3_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
    },
    additional_information_checkbox4: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_4 === 1 && communityRequiredData.value.additional_information_4_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
    },
    additional_information_checkbox5: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_5 === 1 && communityRequiredData.value.additional_information_5_setting?.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE
      ),
    },
    additional_information_select1: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_1 === 1 && communityRequiredData.value.additional_information_1_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
    },
    additional_information_select2: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_2 === 1 && communityRequiredData.value.additional_information_2_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
    },
    additional_information_select3: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_3 === 1 && communityRequiredData.value.additional_information_3_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
    },
    additional_information_select4: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_4 === 1 && communityRequiredData.value.additional_information_4_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
    },
    additional_information_select5: {
      requiredSelect: requiredIf(
        communityRequiredData.value.additional_information_5 === 1 && communityRequiredData.value.additional_information_5_setting?.type == ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ),
    },
  }
})

const rules = computed(() => {
  return {
    display_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    rejoin_intention: {
      requiredSelect: requiredIf(communityRequiredData.value.yelloop_check_enable),
    },
    desired_information: {
      requiredSelect: requiredIf(communityRequiredData.value.yelloop_check_enable),
    },

    corporation_organization_name: {
      required: requiredIf(communityRequiredData.value.corporation_organization_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_department_name: {
      required: requiredIf(communityRequiredData.value.corporation_department_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_start_period: {
      required: requiredIf(communityRequiredData.value.corporation_start_period === 1 && communityRequiredData.value.corporation_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },

    corporation_end_period: {
      required: requiredIf(communityRequiredData.value.corporation_start_period === 1 && communityRequiredData.value.corporation_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
      afterStartDate: function (value) {
        if (
          dayjs(formData.value.corporation_start_period).format('YYYY/MM/DD') !== 'Invalid Date' &&
          dayjs(formData.value.corporation_start_period).format('YYYY/MM/DD') !== dayjs(value).format('YYYY/MM/DD')
        ) {
          return dayjs(value).isSameOrAfter(dayjs(formData.value.corporation_start_period))
        } else {
          return true
        }
      },
    },

    corporation_employee_id: {
      required: requiredIf(communityRequiredData.value.corporation_employee_id === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_email: {
      required: requiredIf(communityRequiredData.value.corporation_email === 1),
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },

    corporation_family_name: {
      required: requiredIf(communityRequiredData.value.corporation_family_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_given_name: {
      required: requiredIf(communityRequiredData.value.corporation_given_name === 1),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_organization_name: {
      required: requiredIf(communityRequiredData.value.school_organization_name === 1),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_faclty_name: {
      required: requiredIf(communityRequiredData.value.school_faclty_name === 1),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_department_name: {
      required: requiredIf(communityRequiredData.value.school_department_name === 1),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_start_period: {
      required: requiredIf(communityRequiredData.value.school_start_period === 1 && communityRequiredData.value.school_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },

    school_end_period: {
      required: requiredIf(communityRequiredData.value.school_start_period === 1 && communityRequiredData.value.school_end_period === 1),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
      afterStartDate: function (value) {
        if (
          dayjs(formData.value.school_start_period).format('YYYY/MM/DD') !== 'Invalid Date' &&
          dayjs(formData.value.school_start_period).format('YYYY/MM/DD') !== dayjs(value).format('YYYY/MM/DD')
        ) {
          return dayjs(value).isSameOrAfter(dayjs(formData.value.school_start_period))
        } else {
          return true
        }
      },
    },

    school_student_id: {
      required: requiredIf(communityRequiredData.value.school_student_id === 1),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_email: {
      required: requiredIf(communityRequiredData.value.school_email === 1),
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },

    school_family_name: {
      required: requiredIf(communityRequiredData.value.school_family_name === 1 && communityRequiredData.value.school_given_name === 1),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_given_name: {
      required: requiredIf(communityRequiredData.value.school_family_name === 1 && communityRequiredData.value.school_given_name === 1),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    additional_information_1: {
      required: requiredIf(
        communityRequiredData.value.additional_information_1 === 1 && communityRequiredData.value.additional_information_1_setting?.type == ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_1_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_1_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_2: {
      required: requiredIf(
        communityRequiredData.value.additional_information_2 === 1 && communityRequiredData.value.additional_information_2_setting?.type == ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_2_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_2_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_3: {
      required: requiredIf(
        communityRequiredData.value.additional_information_3 === 1 && communityRequiredData.value.additional_information_3_setting?.type == ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_3_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_3_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_4: {
      required: requiredIf(
        communityRequiredData.value.additional_information_4 === 1 && communityRequiredData.value.additional_information_4_setting?.type == ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_4_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_4_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_5: {
      required: requiredIf(
        communityRequiredData.value.additional_information_5 === 1 && communityRequiredData.value.additional_information_5_setting?.type == ALUMNI_QUESTION_TYPE.FREE_TEXT
      ),
      maxLength: (value: string) => customMaxLengthAlumni(communityRequiredData.value.additional_information_5_setting?.type, value, 100),
      emoji: function (value) {
        if (communityRequiredData.value.additional_information_5_setting?.type !== ALUMNI_QUESTION_TYPE.FREE_TEXT) {
          return true
        }
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
  }
})
const formData = ref(registerAlumnusCommunityData)
const v$ = useVuelidate(rules, formData)
const vCheckbox$ = useVuelidate(rulesCheckbox, additional_information_checkbox)

watchEffect(() => {
  disableBtn.value = !formData.value.consent_of_community
})

const getAdditionalValue = (index) => {
  if (communityRequiredData.value[`additional_information_${index}`] === 0) return ''
  if (communityRequiredData.value[`additional_information_${index}_setting`]?.type === ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
    if (!isEmpty(additional_information_checkbox.value[`additional_information_checkbox${index}`])) {
      var sort_result = []
      additional_information_checkbox.value[`additional_information_checkbox${index}`].forEach((item) => {
        const index = parseInt(item.substring(item.lastIndexOf('_') + 1), 10)
        sort_result[index] = item
      })
      sort_result = Object.values(sort_result).filter((value) => value !== null)
      return JSON.stringify(sort_result)
    }
    return JSON.stringify(additional_information_checkbox.value[`additional_information_checkbox${index}`])
  } else {
    return communityRequiredData.value[`additional_information_${index}_setting`]?.type === ALUMNI_QUESTION_TYPE.SINGLE_CHOICE
      ? additional_information_checkbox.value[`additional_information_select${index}`]
      : formData.value[`additional_information_${index}`]
  }
}

const formatDataSendToVerify = () => {
  let formDataNow = toRaw(formData.value)
  Array.from({ length: 5 }, (_, i) => i + 1).forEach((i) => {
    formDataNow[`additional_information_${i}`] = getAdditionalValue(i)
  })
  return formDataNow
}

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  vCheckbox$.value.$touch()
  checkSubmit.value = true

  const isCheckedNGItems: Array<{ value: boolean }> = [
    isCheckedNGDisplayName,
    isCheckedNGCorporationOrganizationName,
    isCheckedNGCorporationDepartmentName,
    isCheckedNGCorporationFamilyName,
    isCheckedNGCorporationGivenName,
    isCheckedNGSchoolOrganizationName,
    isCheckedNGSchoolFacltyName,
    isCheckedNGSchoolDepartmentName,
    isCheckedNGSchoolFamilyName,
    isCheckedNGSchoolGivenName,
    isCheckedNGAdditionalInformation1,
    isCheckedNGAdditionalInformation2,
    isCheckedNGAdditionalInformation3,
    isCheckedNGAdditionalInformation4,
    isCheckedNGAdditionalInformation5,
  ]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))
  await Promise.all([
    checkNGDisplayName(),
    checkNGCorporationOrganizationName(),
    checkNGCorporationDepartmentName(),
    checkNGCorporationFamilyName(),
    checkNGCorporationGivenName(),
    checkNGSchoolOrganizationName(),
    checkNGSchoolFacltyName(),
    checkNGSchoolDepartmentName(),
    checkNGSchoolFamilyName(),
    checkNGSchoolGivenName(),
    checkNGAdditionalInformation1(),
    checkNGAdditionalInformation2(),
    checkNGAdditionalInformation3(),
    checkNGAdditionalInformation4(),
    checkNGAdditionalInformation5(),
  ])
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    vCheckbox$.value.$invalid ||
    ngKeyDisplayName.value ||
    ngKeyCorporationOrganizationName.value ||
    ngKeyCorporationDepartmentName.value ||
    ngKeyCorporationFamilyName.value ||
    ngKeyCorporationGivenName.value ||
    ngKeySchoolOrganizationName.value ||
    ngKeySchoolFacltyName.value ||
    ngKeySchoolDepartmentName.value ||
    ngKeySchoolFamilyName.value ||
    ngKeySchoolGivenName.value ||
    ngKeyAdditionalInformation1.value ||
    ngKeyAdditionalInformation2.value ||
    ngKeyAdditionalInformation3.value ||
    ngKeyAdditionalInformation4.value ||
    ngKeyAdditionalInformation5.value
  ) {
    nextTick(() => {
      const elementErrors = document.querySelector('.invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors)
    })
    return
  }
  const dataVerify = formatDataSendToVerify()
  store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_COMMUNITY_VALUE, dataVerify)
  router.push({ path: '/alumni/register_alumnus_community_confirm', query: { invited_code: route.query?.invited_code } })
  localStorage.setItem('checkConfirm', true)
}
const disableCorporation = ref(true)
const disableSchool = ref(true)
const disableInformation = ref(true)
watchEffect(() => {
  disableCorporation.value =
    communityRequiredData?.value.corporation_organization_name === 0 &&
    communityRequiredData?.value.corporation_department_name === 0 &&
    communityRequiredData?.value.corporation_email === 0 &&
    communityRequiredData?.value.corporation_employee_id === 0 &&
    communityRequiredData?.value.corporation_end_period === 0 &&
    communityRequiredData?.value.corporation_family_name === 0 &&
    communityRequiredData?.value.corporation_given_name === 0 &&
    communityRequiredData?.value.corporation_start_period === 0
  disableSchool.value =
    communityRequiredData?.value.school_organization_name === 0 &&
    communityRequiredData?.value.school_department_name === 0 &&
    communityRequiredData?.value.school_email === 0 &&
    communityRequiredData?.value.school_end_period === 0 &&
    communityRequiredData?.value.school_faclty_name === 0 &&
    communityRequiredData?.value.school_family_name === 0 &&
    communityRequiredData?.value.school_given_name === 0 &&
    communityRequiredData?.value.school_start_period === 0 &&
    communityRequiredData?.value.school_student_id === 0
  disableInformation.value =
    communityRequiredData?.value.additional_information_1 === 0 &&
    communityRequiredData?.value.additional_information_2 === 0 &&
    communityRequiredData?.value.additional_information_3 === 0 &&
    communityRequiredData?.value.additional_information_4 === 0 &&
    communityRequiredData?.value.additional_information_5 === 0
})

const isCheckedNGDisplayName = { value: false }
const ngKeyDisplayName = ref<boolean>(false)
const checkNGDisplayName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.display_name.$model })
  ngKeyDisplayName.value = data.data?.data?.has_ngword
  isCheckedNGDisplayName.value = true
}, 200)

const isCheckedNGCorporationOrganizationName = { value: false }
const ngKeyCorporationOrganizationName = ref<boolean>(false)
const checkNGCorporationOrganizationName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_organization_name.$model })
  ngKeyCorporationOrganizationName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationOrganizationName.value = true
}, 200)

const isCheckedNGCorporationDepartmentName = { value: false }
const ngKeyCorporationDepartmentName = ref<boolean>(false)
const checkNGCorporationDepartmentName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_department_name.$model })
  ngKeyCorporationDepartmentName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationDepartmentName.value = true
}, 200)

const isCheckedNGCorporationFamilyName = { value: false }
const ngKeyCorporationFamilyName = ref<boolean>(false)
const checkNGCorporationFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_family_name.$model })
  ngKeyCorporationFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationFamilyName.value = true
}, 200)

const isCheckedNGCorporationGivenName = { value: false }
const ngKeyCorporationGivenName = ref<boolean>(false)
const checkNGCorporationGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_given_name.$model })
  ngKeyCorporationGivenName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationGivenName.value = true
}, 200)

const isCheckedNGSchoolOrganizationName = { value: false }
const ngKeySchoolOrganizationName = ref<boolean>(false)
const checkNGSchoolOrganizationName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_organization_name.$model })
  ngKeySchoolOrganizationName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolOrganizationName.value = true
}, 200)

const isCheckedNGSchoolFacltyName = { value: false }
const ngKeySchoolFacltyName = ref<boolean>(false)
const checkNGSchoolFacltyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_faclty_name.$model })
  ngKeySchoolFacltyName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolFacltyName.value = true
}, 200)

const isCheckedNGSchoolDepartmentName = { value: false }
const ngKeySchoolDepartmentName = ref<boolean>(false)
const checkNGSchoolDepartmentName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_department_name.$model })
  ngKeySchoolDepartmentName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolDepartmentName.value = true
}, 200)

const isCheckedNGSchoolFamilyName = { value: false }
const ngKeySchoolFamilyName = ref<boolean>(false)
const checkNGSchoolFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_family_name.$model })
  ngKeySchoolFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolFamilyName.value = true
}, 200)

const isCheckedNGSchoolGivenName = { value: false }
const ngKeySchoolGivenName = ref<boolean>(false)
const checkNGSchoolGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_given_name.$model })
  ngKeySchoolGivenName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolGivenName.value = true
}, 200)

const isCheckedNGAdditionalInformation1 = { value: false }
const ngKeyAdditionalInformation1 = ref<boolean>(false)
const checkNGAdditionalInformation1 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_1.$model })
  ngKeyAdditionalInformation1.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation1.value = true
}, 200)

const isCheckedNGAdditionalInformation2 = { value: false }
const ngKeyAdditionalInformation2 = ref<boolean>(false)
const checkNGAdditionalInformation2 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_2.$model })
  ngKeyAdditionalInformation2.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation2.value = true
}, 200)

const isCheckedNGAdditionalInformation3 = { value: false }
const ngKeyAdditionalInformation3 = ref<boolean>(false)
const checkNGAdditionalInformation3 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_3.$model })
  ngKeyAdditionalInformation3.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation3.value = true
}, 200)

const isCheckedNGAdditionalInformation4 = { value: false }
const ngKeyAdditionalInformation4 = ref<boolean>(false)
const checkNGAdditionalInformation4 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_4.$model })
  ngKeyAdditionalInformation4.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation4.value = true
}, 200)

const isCheckedNGAdditionalInformation5 = { value: false }
const ngKeyAdditionalInformation5 = ref<boolean>(false)
const checkNGAdditionalInformation5 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_5.$model })
  ngKeyAdditionalInformation5.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation5.value = true
}, 200)

return (_ctx: any,_cache: any) => {
  return (loadingData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (['ERROR_INVALID_PARAMS', 'INVALID_URL_ERROR'].includes(_unref(invalid)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(ErrorMessage), {
            title: _unref(getMessage)(_unref(invalid))
          }, null, 8, ["title"])
        ]))
      : (_unref(alumnusDuplicate))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(alumnusDuplicate) === 'VALIDATE_DUPLICATE')
              ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                  key: 0,
                  title: _unref(translate)('SA20emailSame')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_unref(alumnusDuplicate) === 'ERROR_PARTICIPATED')
              ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                  key: 1,
                  title: _unref(translate)('errorParticipated')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (invitedCodeNotFound.value)
              ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                  key: 0,
                  title: _unref(translate)('INVALID_URL_ERROR')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_unref(invalid))
              ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                  key: 1,
                  title: _unref(getMessage)(_unref(invalid))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(inviteData).corporation_name), 1),
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('SA25headingSecond')), 1),
            _createElementVNode("form", {
              onSubmit: _cache[51] || (_cache[51] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (_unref(communityRequiredData)?.yelloop_check_enable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(translate)('SA20YelloopCheckHeader')), 1),
                    _createVNode(YelloopCheckForm, {
                      isEditProfile: false,
                      v$: _unref(v$),
                      "rejoin-intention": _unref(v$).rejoin_intention.$model,
                      "onUpdate:rejoin-intention": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).rejoin_intention.$model) = $event)),
                      "desired-information": _unref(v$).desired_information.$model,
                      "onUpdate:desired-information": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).desired_information.$model) = $event))
                    }, null, 8, ["v$", "rejoin-intention", "desired-information"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(inviteData).corporation_name) + _toDisplayString(_unref(translate)('SA25titleFirst')), 1),
                _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(translate)('SA25titleSecond')), 1),
                (_ctx.registerFailed)
                  ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                      key: 0,
                      title: _unref(translate)('SA20registerFailed')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(TargetTag, {
                    data: _unref(communityRequiredData)?.supplementary_information,
                    class: _normalizeClass([fullContent.value ? '' : 'p_content'])
                  }, null, 8, ["data", "class"]),
                  (seeMoreBtn.value > 72 && !fullContent.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "span-text text-decoration-underline cursor-pointer",
                        onClick: SeeMore
                      }, _toDisplayString(_unref(translate)('seeMore')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "text-break break-spaces real_height position-absolute",
                    ref: (_value, _refs) => {
                      _refs['supplementaryInformation'] = _value
                      supplementaryInformation.value = _value
                    },
                    innerHTML: _unref(purifyContent)(_unref(communityRequiredData)?.supplementary_information)
                  }, null, 8, _hoisted_15)
                ]),
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_unref(translate)('basicInformation')), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('nickName')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(['form-control', ngKeyDisplayName.value || _unref(v$).display_name.$error ? 'is-invalid' : '']),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).display_name.$model) = $event)),
                        placeholder: _unref(translate)('placeholder'),
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGDisplayName) && _unref(checkNGDisplayName)(...args)))
                      }, null, 42, _hoisted_22), [
                        [
                          _vModelText,
                          _unref(v$).display_name.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (ngKeyDisplayName.value && !_unref(v$).display_name.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                        : _createCommentVNode("", true),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('nickName'),
                        params: [1, 20],
                        validator: _unref(v$).display_name.$errors[0]?.$validator
                      }, null, 8, ["title", "validator"])
                    ])
                  ])
                ]),
                (!disableCorporation.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_24, _toDisplayString(_unref(translate)('SA20enrollment')), 1))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).corporation_organization_name === 1 || _unref(communityRequiredData).corporation_organization_name === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)(`SA20corporationOrganizationName`)), 1),
                      _createElementVNode("div", _hoisted_27, [
                        (_unref(communityRequiredData).corporation_organization_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(['form-control', ngKeyCorporationOrganizationName.value || _unref(v$).corporation_organization_name.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).corporation_organization_name.$model) = $event)),
                            placeholder: _unref(translate)('placeholder'),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationOrganizationName) && _unref(checkNGCorporationOrganizationName)(...args)))
                          }, null, 42, _hoisted_31), [
                            [
                              _vModelText,
                              _unref(v$).corporation_organization_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyCorporationOrganizationName.value && !_unref(v$).corporation_organization_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20corporationOrganizationName`),
                            params: [1, 100],
                            validator: _unref(v$).corporation_organization_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).corporation_department_name === 1 || _unref(communityRequiredData).corporation_department_name === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)(`SA20department`)), 1),
                      _createElementVNode("div", _hoisted_35, [
                        (_unref(communityRequiredData).corporation_department_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(['form-control', ngKeyCorporationDepartmentName.value || _unref(v$).corporation_department_name.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).corporation_department_name.$model) = $event)),
                            placeholder: _unref(translate)(`SA20placeholderDepartment`),
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationDepartmentName) && _unref(checkNGCorporationDepartmentName)(...args)))
                          }, null, 42, _hoisted_39), [
                            [
                              _vModelText,
                              _unref(v$).corporation_department_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyCorporationDepartmentName.value && !_unref(v$).corporation_department_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20department`),
                            params: [1, 100],
                            validator: _unref(v$).corporation_department_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            (_unref(communityRequiredData).corporation_start_period === 1 && _unref(communityRequiredData).corporation_end_period === 1) ||
            (_unref(communityRequiredData).corporation_start_period === 2 && _unref(communityRequiredData).corporation_end_period === 2)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(translate)(`SA20enrollmentPeriod`)), 1),
                      _createElementVNode("div", _hoisted_43, [
                        (_unref(communityRequiredData).corporation_start_period === 1 && _unref(communityRequiredData).corporation_end_period === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_unref(flatPickr), {
                              modelValue: _unref(v$).corporation_start_period.$model,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).corporation_start_period.$model) = $event)),
                              config: _unref(configYM)(_unref(v$).corporation_start_period.$model),
                              class: _normalizeClass(['form-control bg-white', _unref(v$).corporation_start_period.$error ? 'is-invalid' : ''])
                            }, null, 8, ["modelValue", "config", "class"]),
                            _hoisted_48
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20fromEnrollmentPeriod`),
                            params: [1900, 1],
                            validator: _unref(v$).corporation_start_period.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ]),
                        _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(translate)('SA20from')), 1),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_unref(flatPickr), {
                              modelValue: _unref(v$).corporation_end_period.$model,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).corporation_end_period.$model) = $event)),
                              config: _unref(configYM)(_unref(v$).corporation_end_period.$model),
                              class: _normalizeClass(['form-control bg-white', _unref(v$).corporation_end_period.$error ? 'is-invalid' : ''])
                            }, null, 8, ["modelValue", "config", "class"]),
                            _hoisted_52
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20toEnrollmentPeriod`),
                            params: [1900, 1],
                            validator: _unref(v$).corporation_end_period.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).corporation_employee_id === 1 || _unref(communityRequiredData).corporation_employee_id === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)(`SA20employeeID`)), 1),
                      _createElementVNode("div", _hoisted_55, [
                        (_unref(communityRequiredData).corporation_employee_id === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).corporation_employee_id.$model) = $event)),
                            class: _normalizeClass(['form-control', _unref(v$).corporation_employee_id.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)(`SA20placeholderID`)
                          }, null, 10, _hoisted_59), [
                            [
                              _vModelText,
                              _unref(v$).corporation_employee_id.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20employeeID`),
                            params: [1, 20],
                            validator: _unref(v$).corporation_employee_id.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).corporation_email === 1 || _unref(communityRequiredData).corporation_email === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(translate)(`SA20emailEnrollment`)), 1),
                      _createElementVNode("div", _hoisted_62, [
                        (_unref(communityRequiredData).corporation_email === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).corporation_email.$model) = $event)),
                            class: _normalizeClass(['form-control', _unref(v$).corporation_email.$error ? 'is-invalid' : '']),
                            placeholder: "sample@yelloop.jp"
                          }, null, 2), [
                            [
                              _vModelText,
                              _unref(v$).corporation_email.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)('SA20emailEnrollment'),
                            params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                            validator: _unref(v$).corporation_email.$errors[0]?.$validator
                          }, null, 8, ["title", "params", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            (_unref(communityRequiredData).corporation_given_name === 1 && _unref(communityRequiredData).corporation_family_name === 1) ||
            (_unref(communityRequiredData).corporation_given_name === 2 && _unref(communityRequiredData).corporation_family_name === 2)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(translate)(`OE30nameAtTime`)), 1),
                      _createElementVNode("div", _hoisted_68, [
                        (_unref(communityRequiredData).corporation_given_name === 1 && _unref(communityRequiredData).corporation_family_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(translate)(`SA20surnameKanji`)), 1),
                        _createElementVNode("div", _hoisted_72, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).corporation_family_name.$model) = $event)),
                            class: _normalizeClass(['form-control', ngKeyCorporationFamilyName.value || _unref(v$).corporation_family_name.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)('placeholder'),
                            onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationFamilyName) && _unref(checkNGCorporationFamilyName)(...args)))
                          }, null, 42, _hoisted_73), [
                            [
                              _vModelText,
                              _unref(v$).corporation_family_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyCorporationFamilyName.value && !_unref(v$).corporation_family_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20surnameKanji`),
                            params: [1, 20],
                            validator: _unref(v$).corporation_family_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("label", _hoisted_76, _toDisplayString(_unref(translate)(`SA20firstName`)), 1),
                        _createElementVNode("div", _hoisted_77, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).corporation_given_name.$model) = $event)),
                            class: _normalizeClass(['form-control', ngKeyCorporationGivenName.value || _unref(v$).corporation_given_name.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)('placeholder'),
                            onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationGivenName) && _unref(checkNGCorporationGivenName)(...args)))
                          }, null, 42, _hoisted_78), [
                            [
                              _vModelText,
                              _unref(v$).corporation_given_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeyCorporationGivenName.value && !_unref(v$).corporation_given_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20firstName`),
                            params: [1, 20],
                            validator: _unref(v$).corporation_given_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!disableSchool.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_80, _toDisplayString(_unref(translate)('SA20informationAtSchool')), 1))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).school_organization_name === 1 || _unref(communityRequiredData).school_organization_name === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("label", _hoisted_82, _toDisplayString(_unref(translate)(`SA20schoolOrganizationName`)), 1),
                      _createElementVNode("div", _hoisted_83, [
                        (_unref(communityRequiredData).school_organization_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(['form-control', ngKeySchoolOrganizationName.value || _unref(v$).school_organization_name.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(v$).school_organization_name.$model) = $event)),
                            placeholder: _unref(translate)(`placeholder`),
                            onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolOrganizationName) && _unref(checkNGSchoolOrganizationName)(...args)))
                          }, null, 42, _hoisted_87), [
                            [
                              _vModelText,
                              _unref(v$).school_organization_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeySchoolOrganizationName.value && !_unref(v$).school_organization_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20schoolOrganizationName`),
                            params: [1, 100],
                            validator: _unref(v$).school_organization_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).school_faclty_name === 1 || _unref(communityRequiredData).school_faclty_name === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                      _createElementVNode("label", _hoisted_90, _toDisplayString(_unref(translate)(`SA20facultyName`)), 1),
                      _createElementVNode("div", _hoisted_91, [
                        (_unref(communityRequiredData).school_faclty_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(['form-control', ngKeySchoolFacltyName.value || _unref(v$).school_faclty_name.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(v$).school_faclty_name.$model) = $event)),
                            placeholder: _unref(translate)(`SA20placeholderName1`),
                            onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolFacltyName) && _unref(checkNGSchoolFacltyName)(...args)))
                          }, null, 42, _hoisted_95), [
                            [
                              _vModelText,
                              _unref(v$).school_faclty_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeySchoolFacltyName.value && !_unref(v$).school_faclty_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20facultyName`),
                            params: [1, 100],
                            validator: _unref(v$).school_faclty_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).school_department_name === 1 || _unref(communityRequiredData).school_department_name === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                      _createElementVNode("label", _hoisted_98, _toDisplayString(_unref(translate)(`SA20departmentName`)), 1),
                      _createElementVNode("div", _hoisted_99, [
                        (_unref(communityRequiredData).school_department_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(['form-control', ngKeySchoolDepartmentName.value || _unref(v$).school_department_name.$error ? 'is-invalid' : '']),
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(v$).school_department_name.$model) = $event)),
                            placeholder: _unref(translate)(`SA20placeholderName2`),
                            onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolDepartmentName) && _unref(checkNGSchoolDepartmentName)(...args)))
                          }, null, 42, _hoisted_103), [
                            [
                              _vModelText,
                              _unref(v$).school_department_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeySchoolDepartmentName.value && !_unref(v$).school_faclty_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20departmentName`),
                            params: [1, 100],
                            validator: _unref(v$).school_department_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            (_unref(communityRequiredData).school_start_period === 1 && _unref(communityRequiredData).school_end_period === 1) ||
            (_unref(communityRequiredData).school_start_period === 2 && _unref(communityRequiredData).school_end_period === 2)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                      _createElementVNode("label", _hoisted_106, _toDisplayString(_unref(translate)(`SA20periodOfEnrollment`)), 1),
                      _createElementVNode("div", _hoisted_107, [
                        (_unref(communityRequiredData).school_start_period === 1 && _unref(communityRequiredData).school_end_period === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("div", _hoisted_111, [
                            _createVNode(_unref(flatPickr), {
                              modelValue: _unref(v$).school_start_period.$model,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(v$).school_start_period.$model) = $event)),
                              config: _unref(configYM)(_unref(v$).school_start_period.$model),
                              class: _normalizeClass(['form-control bg-white', _unref(v$).school_start_period.$error ? 'is-invalid' : ''])
                            }, null, 8, ["modelValue", "config", "class"]),
                            _hoisted_112
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20fromPeriodOfEnrollment`),
                            params: [1900, 1],
                            validator: _unref(v$).school_start_period.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ]),
                        _createElementVNode("div", _hoisted_113, _toDisplayString(_unref(translate)('SA20from')), 1),
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("div", _hoisted_115, [
                            _createVNode(_unref(flatPickr), {
                              modelValue: _unref(v$).school_end_period.$model,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(v$).school_end_period.$model) = $event)),
                              config: _unref(configYM)(_unref(v$).school_end_period.$model),
                              class: _normalizeClass(['form-control bg-white', _unref(v$).school_end_period.$error ? 'is-invalid' : ''])
                            }, null, 8, ["modelValue", "config", "class"]),
                            _hoisted_116
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20toPeriodOfEnrollment`),
                            params: [1900, 1],
                            validator: _unref(v$).school_end_period.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).school_student_id === 1 || _unref(communityRequiredData).school_student_id === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _createElementVNode("label", _hoisted_118, _toDisplayString(_unref(translate)(`SA20studentID`)), 1),
                      _createElementVNode("div", _hoisted_119, [
                        (_unref(communityRequiredData).school_student_id === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("div", _hoisted_122, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(v$).school_student_id.$model) = $event)),
                            class: _normalizeClass(['form-control', _unref(v$).school_student_id.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)(`SA20placeholderID`)
                          }, null, 10, _hoisted_123), [
                            [
                              _vModelText,
                              _unref(v$).school_student_id.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20studentID`),
                            params: [1, 20],
                            validator: _unref(v$).school_student_id.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).school_email === 1 || _unref(communityRequiredData).school_email === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                      _createElementVNode("label", _hoisted_125, _toDisplayString(_unref(translate)(`SA20emailAttendSchool`)), 1),
                      _createElementVNode("div", _hoisted_126, [
                        (_unref(communityRequiredData).school_email === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(v$).school_email.$model) = $event)),
                            class: _normalizeClass(['form-control', _unref(v$).school_email.$error ? 'is-invalid' : '']),
                            placeholder: "sample@yelloop.jp"
                          }, null, 2), [
                            [
                              _vModelText,
                              _unref(v$).school_email.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20emailAttendSchool`),
                            params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                            validator: _unref(v$).school_email.$errors[0]?.$validator
                          }, null, 8, ["title", "params", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            (_unref(communityRequiredData).school_family_name === 1 && _unref(communityRequiredData).school_given_name === 1) ||
            (_unref(communityRequiredData).school_family_name === 2 && _unref(communityRequiredData).school_given_name === 2)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _createElementVNode("label", _hoisted_131, _toDisplayString(_unref(translate)(`SA20nameAtSchool`)), 1),
                      _createElementVNode("div", _hoisted_132, [
                        (_unref(communityRequiredData).school_family_name === 1 && _unref(communityRequiredData).school_given_name === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("label", _hoisted_135, _toDisplayString(_unref(translate)(`SA20surnameKanji`)), 1),
                        _createElementVNode("div", _hoisted_136, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(v$).school_family_name.$model) = $event)),
                            class: _normalizeClass(['form-control', ngKeySchoolFamilyName.value || _unref(v$).school_family_name.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)('placeholder'),
                            onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolFamilyName) && _unref(checkNGSchoolFamilyName)(...args)))
                          }, null, 42, _hoisted_137), [
                            [
                              _vModelText,
                              _unref(v$).school_family_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeySchoolFamilyName.value && !_unref(v$).school_family_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20surnameKanji`),
                            params: [1, 20],
                            validator: _unref(v$).school_family_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("label", _hoisted_140, _toDisplayString(_unref(translate)(`SA20firstName`)), 1),
                        _createElementVNode("div", _hoisted_141, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(v$).school_given_name.$model) = $event)),
                            class: _normalizeClass(['form-control', ngKeySchoolGivenName.value || _unref(v$).school_given_name.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)('placeholder'),
                            onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolGivenName) && _unref(checkNGSchoolGivenName)(...args)))
                          }, null, 42, _hoisted_142), [
                            [
                              _vModelText,
                              _unref(v$).school_given_name.$model,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (ngKeySchoolGivenName.value && !_unref(v$).school_given_name.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_143, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: _unref(translate)(`SA20firstName`),
                            params: [1, 20],
                            validator: _unref(v$).school_given_name.$errors[0]?.$validator
                          }, null, 8, ["title", "validator"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!disableInformation.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_144, _toDisplayString(_unref(translate)('additionalInformation')), 1))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).additional_information_1 === 1 || _unref(communityRequiredData).additional_information_1 === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                      _createElementVNode("label", _hoisted_146, [
                        _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_1_question) + " ", 1),
                        (
                _unref(communityRequiredData)?.additional_information_1_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                _unref(communityRequiredData)?.additional_information_1_setting?.data?.length > 1
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        (_unref(communityRequiredData).additional_information_1 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(communityRequiredData)?.additional_information_1_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                            _createElementVNode("div", _hoisted_151, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(['form-control', ngKeyAdditionalInformation1.value || _unref(v$).additional_information_1.$error ? 'is-invalid' : '']),
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(v$).additional_information_1.$model) = $event)),
                                onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation1) && _unref(checkNGAdditionalInformation1)(...args))),
                                placeholder: _unref(placeholderDefault)
                              }, null, 42, _hoisted_152), [
                                [
                                  _vModelText,
                                  _unref(v$).additional_information_1.$model,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (ngKeyAdditionalInformation1.value && !_unref(v$).additional_information_1.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                : _createCommentVNode("", true),
                              _createVNode(InputErrorMessage, {
                                title: _unref(communityRequiredData).additional_information_1_question,
                                params: [1, 100],
                                validator: _unref(v$).additional_information_1.$errors[0]?.$validator
                              }, null, 8, ["title", "validator"])
                            ])
                          ]))
                        : (_unref(communityRequiredData)?.additional_information_1_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                              _createElementVNode("div", _hoisted_155, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select1.$error ? 'is-invalid' : '']]),
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(vCheckbox$).additional_information_select1.$model) = $event)),
                                  ref: (_value, _refs) => {
                                    _refs['selectChild'] = _value
                                  }
                                }, [
                                  _createElementVNode("option", _hoisted_156, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_1_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: index
                                    }, _toDisplayString(item), 9, _hoisted_157))
                                  }), 128))
                                ], 2), [
                                  [_vModelSelect, _unref(vCheckbox$).additional_information_select1.$model]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_1_question,
                                  validator: _unref(vCheckbox$).additional_information_select1.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_158, [
                              _createElementVNode("div", _hoisted_159, [
                                _createElementVNode("div", _hoisted_160, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_1_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox1.$error ? 'is-invalid' : '']]),
                                      key: index
                                    }, [
                                      _createElementVNode("label", _hoisted_161, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          class: "mr-1 cursor-pointer form-check-input",
                                          value: `${item}_ALUMNI_IDX_${index}`,
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox1) = $event))
                                        }, null, 8, _hoisted_162), [
                                          [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox1]
                                        ]),
                                        _createElementVNode("div", _hoisted_163, _toDisplayString(item), 1)
                                      ])
                                    ], 2))
                                  }), 128)),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(communityRequiredData).additional_information_1_question,
                                    params: [1, 100],
                                    validator: _unref(vCheckbox$).additional_information_checkbox1.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).additional_information_2 === 1 || _unref(communityRequiredData).additional_information_2 === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                      _createElementVNode("label", _hoisted_165, [
                        _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_2_question) + " ", 1),
                        (
                _unref(communityRequiredData)?.additional_information_2_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                _unref(communityRequiredData)?.additional_information_2_setting?.data?.length > 1
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_166, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_167, [
                        (_unref(communityRequiredData).additional_information_2 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(communityRequiredData)?.additional_information_2_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                            _createElementVNode("div", _hoisted_170, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(['form-control', ngKeyAdditionalInformation2.value || _unref(v$).additional_information_2.$error ? 'is-invalid' : '']),
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(v$).additional_information_2.$model) = $event)),
                                onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation2) && _unref(checkNGAdditionalInformation2)(...args))),
                                placeholder: _unref(placeholderDefault)
                              }, null, 42, _hoisted_171), [
                                [
                                  _vModelText,
                                  _unref(v$).additional_information_2.$model,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (ngKeyAdditionalInformation2.value && !_unref(v$).additional_information_2.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_172, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                : _createCommentVNode("", true),
                              _createVNode(InputErrorMessage, {
                                title: _unref(communityRequiredData).additional_information_2_question,
                                params: [1, 100],
                                validator: _unref(v$).additional_information_2.$errors[0]?.$validator
                              }, null, 8, ["title", "validator"])
                            ])
                          ]))
                        : (_unref(communityRequiredData)?.additional_information_2_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                              _createElementVNode("div", _hoisted_174, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select2.$error ? 'is-invalid' : '']]),
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(vCheckbox$).additional_information_select2.$model) = $event)),
                                  ref: (_value, _refs) => {
                                    _refs['selectChild'] = _value
                                  }
                                }, [
                                  _createElementVNode("option", _hoisted_175, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_2_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: index
                                    }, _toDisplayString(item), 9, _hoisted_176))
                                  }), 128))
                                ], 2), [
                                  [_vModelSelect, _unref(vCheckbox$).additional_information_select2.$model]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_2_question,
                                  validator: _unref(vCheckbox$).additional_information_select2.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_177, [
                              _createElementVNode("div", _hoisted_178, [
                                _createElementVNode("div", _hoisted_179, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_2_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox2.$error ? 'is-invalid' : '']]),
                                      key: index
                                    }, [
                                      _createElementVNode("label", _hoisted_180, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          class: "mr-1 cursor-pointer form-check-input",
                                          value: `${item}_ALUMNI_IDX_${index}`,
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox2) = $event))
                                        }, null, 8, _hoisted_181), [
                                          [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox2]
                                        ]),
                                        _createElementVNode("div", _hoisted_182, _toDisplayString(item), 1)
                                      ])
                                    ], 2))
                                  }), 128)),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(communityRequiredData).additional_information_2_question,
                                    params: [1, 100],
                                    validator: _unref(vCheckbox$).additional_information_checkbox2.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).additional_information_3 === 1 || _unref(communityRequiredData).additional_information_3 === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                      _createElementVNode("label", _hoisted_184, [
                        _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_3_question) + " ", 1),
                        (
                _unref(communityRequiredData)?.additional_information_3_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                _unref(communityRequiredData)?.additional_information_3_setting?.data?.length > 1
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_185, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_186, [
                        (_unref(communityRequiredData).additional_information_3 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(communityRequiredData)?.additional_information_3_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                            _createElementVNode("div", _hoisted_189, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(['form-control', ngKeyAdditionalInformation3.value || _unref(v$).additional_information_3.$error ? 'is-invalid' : '']),
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(v$).additional_information_3.$model) = $event)),
                                onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation3) && _unref(checkNGAdditionalInformation3)(...args))),
                                placeholder: _unref(placeholderDefault)
                              }, null, 42, _hoisted_190), [
                                [
                                  _vModelText,
                                  _unref(v$).additional_information_3.$model,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (ngKeyAdditionalInformation3.value && !_unref(v$).additional_information_3.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_191, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                : _createCommentVNode("", true),
                              _createVNode(InputErrorMessage, {
                                title: _unref(communityRequiredData).additional_information_3_question,
                                params: [1, 100],
                                validator: _unref(v$).additional_information_3.$errors[0]?.$validator
                              }, null, 8, ["title", "validator"])
                            ])
                          ]))
                        : (_unref(communityRequiredData)?.additional_information_3_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                              _createElementVNode("div", _hoisted_193, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select3.$error ? 'is-invalid' : '']]),
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(vCheckbox$).additional_information_select3.$model) = $event)),
                                  ref: (_value, _refs) => {
                                    _refs['selectChild'] = _value
                                  }
                                }, [
                                  _createElementVNode("option", _hoisted_194, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_3_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: index
                                    }, _toDisplayString(item), 9, _hoisted_195))
                                  }), 128))
                                ], 2), [
                                  [_vModelSelect, _unref(vCheckbox$).additional_information_select3.$model]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_3_question,
                                  validator: _unref(vCheckbox$).additional_information_select3.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_196, [
                              _createElementVNode("div", _hoisted_197, [
                                _createElementVNode("div", _hoisted_198, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_3_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox3.$error ? 'is-invalid' : '']]),
                                      key: index
                                    }, [
                                      _createElementVNode("label", _hoisted_199, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          class: "mr-1 cursor-pointer form-check-input",
                                          value: `${item}_ALUMNI_IDX_${index}`,
                                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox3) = $event))
                                        }, null, 8, _hoisted_200), [
                                          [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox3]
                                        ]),
                                        _createElementVNode("div", _hoisted_201, _toDisplayString(item), 1)
                                      ])
                                    ], 2))
                                  }), 128)),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(communityRequiredData).additional_information_3_question,
                                    params: [1, 100],
                                    validator: _unref(vCheckbox$).additional_information_checkbox3.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).additional_information_4 === 1 || _unref(communityRequiredData).additional_information_4 === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                      _createElementVNode("label", _hoisted_203, [
                        _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_4_question) + " ", 1),
                        (
                _unref(communityRequiredData)?.additional_information_4_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                _unref(communityRequiredData)?.additional_information_4_setting?.data?.length > 1
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_204, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_205, [
                        (_unref(communityRequiredData).additional_information_4 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(communityRequiredData)?.additional_information_4_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                            _createElementVNode("div", _hoisted_208, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(['form-control', ngKeyAdditionalInformation4.value || _unref(v$).additional_information_4.$error ? 'is-invalid' : '']),
                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(v$).additional_information_4.$model) = $event)),
                                onChange: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation4) && _unref(checkNGAdditionalInformation4)(...args))),
                                placeholder: _unref(placeholderDefault)
                              }, null, 42, _hoisted_209), [
                                [
                                  _vModelText,
                                  _unref(v$).additional_information_4.$model,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (ngKeyAdditionalInformation4.value && !_unref(v$).additional_information_4.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_210, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                : _createCommentVNode("", true),
                              _createVNode(InputErrorMessage, {
                                title: _unref(communityRequiredData).additional_information_4_question,
                                params: [1, 100],
                                validator: _unref(v$).additional_information_4.$errors[0]?.$validator
                              }, null, 8, ["title", "validator"])
                            ])
                          ]))
                        : (_unref(communityRequiredData)?.additional_information_4_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                              _createElementVNode("div", _hoisted_212, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select4.$error ? 'is-invalid' : '']]),
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(vCheckbox$).additional_information_select4.$model) = $event)),
                                  ref: (_value, _refs) => {
                                    _refs['selectChild'] = _value
                                  }
                                }, [
                                  _createElementVNode("option", _hoisted_213, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_4_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: index
                                    }, _toDisplayString(item), 9, _hoisted_214))
                                  }), 128))
                                ], 2), [
                                  [_vModelSelect, _unref(vCheckbox$).additional_information_select4.$model]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_4_question,
                                  validator: _unref(vCheckbox$).additional_information_select4.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_215, [
                              _createElementVNode("div", _hoisted_216, [
                                _createElementVNode("div", _hoisted_217, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_4_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox4.$error ? 'is-invalid' : '']]),
                                      key: index
                                    }, [
                                      _createElementVNode("label", _hoisted_218, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          class: "mr-1 cursor-pointer form-check-input",
                                          value: `${item}_ALUMNI_IDX_${index}`,
                                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox4) = $event))
                                        }, null, 8, _hoisted_219), [
                                          [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox4]
                                        ]),
                                        _createElementVNode("div", _hoisted_220, _toDisplayString(item), 1)
                                      ])
                                    ], 2))
                                  }), 128)),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(communityRequiredData).additional_information_4_question,
                                    params: [1, 100],
                                    validator: _unref(vCheckbox$).additional_information_checkbox4.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(communityRequiredData).additional_information_5 === 1 || _unref(communityRequiredData).additional_information_5 === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                      _createElementVNode("label", _hoisted_222, [
                        _createTextVNode(_toDisplayString(_unref(communityRequiredData).additional_information_5_question) + " ", 1),
                        (
                _unref(communityRequiredData)?.additional_information_5_setting?.type == _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE &&
                _unref(communityRequiredData)?.additional_information_5_setting?.data?.length > 1
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_223, _toDisplayString(_unref(translate)('multipleSelectionsPossible')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_224, [
                        (_unref(communityRequiredData).additional_information_5 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_225, [
                              _createVNode(Status)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(communityRequiredData)?.additional_information_5_setting?.type == _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                            _createElementVNode("div", _hoisted_227, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(['form-control', ngKeyAdditionalInformation5.value || _unref(v$).additional_information_5.$error ? 'is-invalid' : '']),
                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(v$).additional_information_5.$model) = $event)),
                                onChange: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation5) && _unref(checkNGAdditionalInformation5)(...args))),
                                placeholder: _unref(placeholderDefault)
                              }, null, 42, _hoisted_228), [
                                [
                                  _vModelText,
                                  _unref(v$).additional_information_5.$model,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (ngKeyAdditionalInformation5.value && !_unref(v$).additional_information_5.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_229, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                : _createCommentVNode("", true),
                              _createVNode(InputErrorMessage, {
                                title: _unref(communityRequiredData).additional_information_5_question,
                                params: [1, 100],
                                validator: _unref(v$).additional_information_5.$errors[0]?.$validator
                              }, null, 8, ["title", "validator"])
                            ])
                          ]))
                        : (_unref(communityRequiredData)?.additional_information_5_setting?.type == _unref(ALUMNI_QUESTION_TYPE).SINGLE_CHOICE)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                              _createElementVNode("div", _hoisted_231, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["form-select", ['form-control', _unref(vCheckbox$).additional_information_select5.$error ? 'is-invalid' : '']]),
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(vCheckbox$).additional_information_select5.$model) = $event)),
                                  ref: (_value, _refs) => {
                                    _refs['selectChild'] = _value
                                  }
                                }, [
                                  _createElementVNode("option", _hoisted_232, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_5_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: index
                                    }, _toDisplayString(item), 9, _hoisted_233))
                                  }), 128))
                                ], 2), [
                                  [_vModelSelect, _unref(vCheckbox$).additional_information_select5.$model]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_5_question,
                                  validator: _unref(vCheckbox$).additional_information_select5.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_234, [
                              _createElementVNode("div", _hoisted_235, [
                                _createElementVNode("div", _hoisted_236, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communityRequiredData)?.additional_information_5_setting?.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["mt-1 col-xs-12 col-md-6 col-lg-4 d-flex word-wrapper", [_unref(vCheckbox$).additional_information_checkbox5.$error ? 'is-invalid' : '']]),
                                      key: index
                                    }, [
                                      _createElementVNode("label", _hoisted_237, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          class: "mr-1 cursor-pointer form-check-input",
                                          value: `${item}_ALUMNI_IDX_${index}`,
                                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((additional_information_checkbox.value.additional_information_checkbox5) = $event))
                                        }, null, 8, _hoisted_238), [
                                          [_vModelCheckbox, additional_information_checkbox.value.additional_information_checkbox5]
                                        ]),
                                        _createElementVNode("div", _hoisted_239, _toDisplayString(item), 1)
                                      ])
                                    ], 2))
                                  }), 128)),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(communityRequiredData).additional_information_5_question,
                                    params: [1, 100],
                                    validator: _unref(vCheckbox$).additional_information_checkbox5.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_240, [
                _createElementVNode("h1", _hoisted_241, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('precautions')), 1),
                _createElementVNode("div", _hoisted_242, _toDisplayString(_unref(termsCommunity).term_of_service), 1),
                _createElementVNode("div", _hoisted_243, [
                  _createElementVNode("label", {
                    for: _ctx.community_name,
                    class: "mt-1 ms-2"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: _ctx.community_name,
                      type: "checkbox",
                      class: "mr-1 cursor-pointer form-check-input",
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((formData.value.consent_of_community) = $event))
                    }, null, 8, _hoisted_245), [
                      [_vModelCheckbox, formData.value.consent_of_community]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
                  ], 8, _hoisted_244)
                ]),
                (!formData.value.consent_of_community && checkSubmit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('SA20communityError')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_247, [
                _createVNode(Button, {
                  title: _unref(translate)('titleButtonConfirm'),
                  type: 'secondary',
                  onClick: onSubmit,
                  disabled: disableBtn.value
                }, null, 8, ["title", "disabled"])
              ])
            ], 32)
          ]))
}
}

})